import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, Tabs, Tab, Paper } from '@mui/material';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import GridOnIcon from '@mui/icons-material/GridOn';
import buildRoute from 'components/buildRoute';
import PageHeader from 'components/PageHeader';
import OrganizationsManagement from './components/OrganizationsManagement';
import ExperimentsList from './components/ExperimentsList';

function TabPanel({ children, value, index }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`registry-admin-tabpanel-${index}`}
      aria-labelledby={`registry-admin-tab-${index}`}
    >
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
}

export const RegistryAdminPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get('tab');
  const [currentTab, setCurrentTab] = useState(tabParam ? parseInt(tabParam, 10) : 0);

  // Update tab when URL parameter changes
  useEffect(() => {
    const param = searchParams.get('tab');
    if (param) {
      const tabIndex = parseInt(param, 10);
      if (tabIndex >= 0 && tabIndex <= 1) {
        setCurrentTab(tabIndex);
      }
    }
  }, [searchParams]);

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
    setSearchParams({ tab: newValue });
  };

  return (
    <>
      <PageHeader
        title="Registry Admin"
        subtitle="Manage organizations and users, and view all experiments"
      />

      <Paper sx={{ width: '100%', mt: 3 }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={currentTab}
            onChange={handleTabChange}
            aria-label="registry admin panel tabs"
          >
            <Tab
              icon={<CorporateFareIcon />}
              iconPosition="start"
              label="Organizations"
              id="registry-admin-tab-0"
              aria-controls="registry-admin-tabpanel-0"
            />
            <Tab
              icon={<GridOnIcon />}
              iconPosition="start"
              label="Experiments"
              id="registry-admin-tab-1"
              aria-controls="registry-admin-tabpanel-1"
            />
          </Tabs>
        </Box>

        <TabPanel value={currentTab} index={0}>
          <OrganizationsManagement />
        </TabPanel>

        <TabPanel value={currentTab} index={1}>
          <ExperimentsList />
        </TabPanel>
      </Paper>
    </>
  );
};

const routeArgs = {
  element: <RegistryAdminPage />,
};

export default buildRoute(routeArgs);
